import { render, staticRenderFns } from "./CollaboratorsDialog.vue?vue&type=template&id=5af1e898&scoped=true"
import script from "./CollaboratorsDialog.vue?vue&type=script&lang=js"
export * from "./CollaboratorsDialog.vue?vue&type=script&lang=js"
import style0 from "./CollaboratorsDialog.vue?vue&type=style&index=0&id=5af1e898&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af1e898",
  null
  
)

export default component.exports